import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getCarrierProfileLoaded } from '../../../selectors/Manage/selector';
import { EVENT, SCREEN } from '../../../utils/constants.analytics';
import { logEvent, setScreenName } from '../../../utils/Analytics';
import { getUserMasterData, getRefreshStatus } from '../../../selectors/selector';
import { loadCarrierData } from '../../../actions/manage/action';
import saga from '../../../saga/Manage/saga';
import useInjectSaga from '../../../utils/injectSaga';
import CarrierProfilePage from '../../pages/CarrierProfilePage/CarrierProfilePage';
import { compose } from 'redux';
import reducer from '../../../reducers/manage/reducer';
import useInjectReducer from '../../../utils/injectReducer';

export const CarrierProfileContainer = (props: any) => {

  useEffect(() => {
    setScreenName(SCREEN.CARRIER_PROFILE);
    logEvent(EVENT.SV_VIEW_CARRIER_PROFILE, {
      screen: SCREEN.CARRIER_PROFILE,
      carrierId: props.userDetails && props.userDetails.memberDetailsResponse &&
      props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.carrierId
    });
  }, []);

  return <CarrierProfilePage {...props}/>;
};

const mapStateToProps = createStructuredSelector({
  userDetails: getUserMasterData(),
  loaded: getCarrierProfileLoaded(),
  isPullToRefresh: getRefreshStatus(),
});

export const mapDispatchToProps = (dispatch: Function) => ({
  loadCarrierProfile: (payload: any) => dispatch(loadCarrierData(payload))
});
const key = 'manage';
const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withSaga = useInjectSaga({ key, saga });
const withReducer = useInjectReducer({key, reducer});

export default compose(withConnect, withReducer, withSaga)(CarrierProfileContainer);
